// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertOutlinedSvg from "@ant-design/icons-svg/es/asn/AlertOutlined";
import AntdIcon from '../components/AntdIcon';

var AlertOutlined = function AlertOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertOutlinedSvg
  }));
};

AlertOutlined.displayName = 'AlertOutlined';
export default React.forwardRef(AlertOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlertOutlined.js
// module id = 531
// module chunks = 0